<template>
  <span>
    <Tooltip
      v-if="!reverse"
      class="my-4 mr-4"
      color="error"
      :text="$t('globals.remove')"
      top
    >
      <v-icon
        small
        color="error"
        v-bind="$attrs"
        v-on="$listeners"
        @click.stop="openConfirmationDialog = true"
      >
        mdi-delete
      </v-icon>
    </Tooltip>

    <Tooltip
      v-else
      class="my-4 mr-4"
      color="warning"
      text="Restaurar"
      top
    >
      <v-icon
        small
        color="warning"
        v-bind="$attrs"
        v-on="$listeners"
        @click.stop="openConfirmationDialog = true"
      >
        mdi-backup-restore
      </v-icon>
    </Tooltip>
    
    <DialogConfirmation 
      v-if="openConfirmationDialog && !reverse" 
      :title="$t('icon_remove.remove_item')" 
      type="warning" 
      :opened="openConfirmationDialog" 
      @on-submit="submit" 
      @on-cancel="openConfirmationDialog = false">
        {{$t('icon_remove.sure_msg')}}
    </DialogConfirmation>

    <DialogConfirmation 
      v-else
      :title="$t('icon_remove.restore_item')" 
      type="warning" 
      :opened="openConfirmationDialog" 
      @on-submit="submit" 
      @on-cancel="openConfirmationDialog = false">
        {{$t('icon_remove.restore')}}
    </DialogConfirmation>
  </span>
</template>

<script>
  import DialogConfirmation from '@/components/ui/DialogConfirmation.vue';
  import Tooltip from '@/components/ui/Tooltip.vue';
  export default {
    name: 'uiIconRemove',
    components: {
      DialogConfirmation,
      Tooltip
    },
    props:{
      reverse:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        openConfirmationDialog: false,
      }
    },
    methods: {
      submit() {
        this.openConfirmationDialog = false
        this.$emit('on-submit')
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>